import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.response.use(
    (res) => res,
    async (err) => {
        const orig = err.config;
        if (err.response?.status === 401 && !orig._retry && !orig.url?.includes("/auth/")) {
            orig._retry = true;
            try {
                await api.post("/auth/refresh");
                return api(orig);
            } catch (e) {
                /* fall through */
            }
        }
        return Promise.reject(err);
    }
);

export function formatApiError(err) {
    const detail = err?.response?.data?.detail;
    if (detail == null) return "Etwas ist schiefgelaufen. Bitte erneut versuchen.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
    return String(detail);
}
